import { FC } from 'react'

import { Icon } from '~/components/Icon'

import theme from '~/theme'

import { translate } from '~/utils/translate'

import * as Styled from './styles'
import { IProcessingImageFeedbackProps } from './types'

export const ProcessingImageFeedback: FC<IProcessingImageFeedbackProps> = ({ started, complete, success }) => {
  return (
    <Styled.Container data-testid="processing-image-feedback-component">
      <>
        {success && complete ? (
          <Icon name="successCheckMark" size="40px" color={theme.colors.growingNature} />
        ) : (
          <Icon name="alarmClock" size="40px" color={theme.colors.neutral.black700} />
        )}
      </>
      <Styled.Status data-testid="psi-status">
        {complete
          ? translate('IMAGE_INPUT_PROCESSING_STATUS_SUCCESS')
          : translate('IMAGE_INPUT_PROCESSING_STATUS_PROCESSING')}
      </Styled.Status>
      <Styled.ProgressContainer data-testid="pbar-container">
        <Styled.ProgressBar data-testid="pbar-bar" complete={complete} started={started} />
      </Styled.ProgressContainer>
      <Styled.Disclaimer data-testid="psi-disclaimer">
        <Icon name="padlock" size="16px" color={theme.colors.neutral.black700} />
        {translate('IMAGE_INPUT_PROCESSING_PRIVACY_DISCLAIMER')}
      </Styled.Disclaimer>
    </Styled.Container>
  )
}
